import { Box, TableCell, Typography } from "@mui/material";
import { AggregateScoresNode } from "../FirewatchPage";
import { FirewatchChip } from "./FirewatchChip";
import { ClampWithTooltip } from "~/components/ClampWithTooltip/ClampWithTooltip";
import { useFirewatchException } from "~/components/FirewatchRow/hooks/useFirewatchException";
import { Format } from "~/lib/date";

export type CheckCellProps = {
  row: AggregateScoresNode;
  isSmallTable?: boolean;
  noTags?: boolean;
  exceptionHref?: string;
  maxWidth?: number;
};

export function CheckCell({
  row,
  isSmallTable,
  noTags,
  maxWidth,
}: CheckCellProps) {
  const { tags } = row || {};
  const { hasException } = useFirewatchException({
    row,
  });

  return (
    <TableCell sx={isSmallTable ? { pl: "5px !important" } : { maxWidth }}>
      <ClampWithTooltip>
        <Typography
          sx={{
            fontSize: isSmallTable ? 12 : 14,
            fontWeight: isSmallTable ? 400 : 700,
            lineHeight: "16px",
            color: hasException ? "text.secondary" : "text.primary",
          }}
        >
          {row?.title || row?.nodeTitle}
        </Typography>
      </ClampWithTooltip>

      {!isSmallTable && (
        <Box
          display="flex"
          gap={1}
          alignItems="center"
          mt={hasException || (tags?.length || 0) > 0 ? 1 : 0}
          sx={{ overflowX: "scroll", scrollbarWidth: "none" }}
        >
          {!noTags && (
            <Box display="flex" gap={1}>
              {tags?.map((tag) => (
                <FirewatchChip
                  key={tag.key}
                  tag={tag}
                  inactive={hasException}
                />
              ))}
            </Box>
          )}
          {/*TODO: we'll to remove this to tag soon since they should be already included in "tags"*/}
          {row.lastScannedAt && (
            <FirewatchChip
              tag={{
                key: "Last confirmed",
                value: Format(row.lastScannedAt, "MM/dd/yy"),
                __typename: "Tag",
              }}
              inactive={hasException}
            />
          )}
        </Box>
      )}
    </TableCell>
  );
}
